"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.GET_PAYMENT_METHOD_FOR_OFFER_CHANGE = void 0;
exports.GET_PAYMENT_METHOD_FOR_OFFER_CHANGE = {
    USER_NOT_FOUND: {
        usecase: "GET_PAYMENT_METHOD_FOR_OFFER_CHANGE",
        type: "USER_NOT_FOUND",
        messageLangMap: {
            "PT-BR": "Usuário não encontrado.",
            "EN-US": "User not found.",
        },
    },
    OFFER_NOT_FOUND: {
        usecase: "GET_PAYMENT_METHOD_FOR_OFFER_CHANGE",
        type: "OFFER_NOT_FOUND",
        messageLangMap: {
            "PT-BR": "Oferta não encontrada.",
            "EN-US": "Offer not found.",
        },
    },
    TRAVEL_NOT_FOUND: {
        usecase: "GET_PAYMENT_METHOD_FOR_OFFER_CHANGE",
        type: "TRAVEL_NOT_FOUND",
        messageLangMap: {
            "PT-BR": "Viagem não encontrada.",
            "EN-US": "Travel not found.",
        },
    },
    SUPPLIER_CONFIG_NOT_FOUND: {
        usecase: "GET_PAYMENT_METHOD_FOR_OFFER_CHANGE",
        type: "SUPPLIER_CONFIG_NOT_FOUND",
        messageLangMap: {
            "PT-BR": "Configuração do fornecedor não encontrada.",
            "EN-US": "Supplier configuration not found.",
        },
    },
};
